// @flow
import * as React from 'react'

export type PlayerPropsType = {
  isPlaying: boolean,
  src: string,
  onCurrentTimeChange: (formattedTime: string) => void,
  onDurationSet: (formattedTime: string) => void,
  onAudioEnded: () => void
}

export default function Audio ({
  isPlaying,
  src,
  onCurrentTimeChange,
  onDurationSet,
  onAudioEnded
}: PlayerPropsType): React.Node {
  const ref = React.useRef(null)
  if (ref.current) isPlaying ? ref.current.play() : ref.current.pause()

  const formatTime = (time: ?number): string => {
    const timeInSeconds: number = Math.round(time || 0)
    if (timeInSeconds && timeInSeconds > 0) {
      const minutes: number = Math.floor(timeInSeconds / 60)
      const seconds = timeInSeconds - minutes * 60
      if (seconds < 10) {
        return minutes + ':0' + seconds
      }
      return minutes + ':' + seconds
    }
    return '0:00'
  }

  const handleOnTimeUpdate = (currentTimeInSeconds: number): void => {
    const formattedTime = formatTime(currentTimeInSeconds)
    onCurrentTimeChange(formattedTime)
  }

  const handleOnLoadedData = (durationInSeconds: number): void => {
    const formattedTime = formatTime(durationInSeconds)
    onDurationSet(formattedTime)
  }

  return (
    <audio
      ref={ref}
      src={src}
      onTimeUpdate={(event: any): void =>
        handleOnTimeUpdate(event.target.currentTime)
      }
      onLoadedData={(event: any): void =>
        handleOnLoadedData(event.target.duration)
      }
      onEnded={(): void => onAudioEnded()}
    />
  )
}
